import { PERMISSIONS, type Permission } from '@/shared/constants';
import { ADDON_BUY_PERMISSIONS } from './addons';

export type MarketplaceTab = 'addons' | 'devices';

export const MARKETPLACE_ACCESS_PERMISSIONS: Permission[] = [
	...Array.from(ADDON_BUY_PERMISSIONS),
	PERMISSIONS.DEVICES_MARKETPLACE_READ,
];
